import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsCL from '@angular/common/locales/es-CL';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import localePt from '@angular/common/locales/pt';


registerLocaleData(localeEs, 'es');
registerLocaleData(localeEsCL, 'es-CL');
registerLocaleData(localePt, 'pt');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
